export const COMPANY_INFO_TABS = {
  overview: { name: '기업개요', path: '', dataPath: '' as const },
  recruit: {
    name: '채용공고',
    path: 'recruit',
    dataPath: 'activities' as const,
  },
  coverletter: {
    name: '합격자소서',
    path: 'coverletter',
    dataPath: 'coverLetters' as const,
  },
  review: { name: '합격후기', path: 'review', dataPath: 'reviews' as const },
  qna: { name: '현직자Q&A', path: 'qna', dataPath: 'qna' as const },
} as const

export type CompanyInfoTab = keyof typeof COMPANY_INFO_TABS
export type CompanyInfoTabInfo = (typeof COMPANY_INFO_TABS)[CompanyInfoTab]

export function getCompanyInfoActiveTab(pathname: string): CompanyInfoTab {
  if (pathname.includes('/recruit')) return 'recruit'
  if (pathname.includes('/coverletter')) return 'coverletter'
  if (pathname.includes('/review')) return 'review'
  if (pathname.includes('/qna')) return 'qna'
  return 'overview'
}
